const state = {
	ai_road_point_selection: false,
	ai_road_preview_data: {
		x1: undefined,
		y1: undefined,
		z1: undefined,
		x2: undefined,
		y2: undefined,
		z2: undefined,
		startPointHeightAbovePointCloud: undefined,
		startPointHeightAboveDesignData: undefined,
		endPointHeightAbovePointCloud: undefined,
		endPointHeightAboveDesignData: undefined,
	},
};

const mutations = {
	set_ai_road_point_selection(state, ai_road_point_selection) {
		state.ai_road_point_selection = ai_road_point_selection;
	},
	set_ai_road_preview_data(state, obj) {
		state.ai_road_preview_data.x1 = obj.x1;
		state.ai_road_preview_data.y1 = obj.y1;
		state.ai_road_preview_data.z1 = obj.z1;
		state.ai_road_preview_data.x2 = obj.x2;
		state.ai_road_preview_data.y2 = obj.y2;
		state.ai_road_preview_data.z2 = obj.z2;
		state.ai_road_preview_data.startPointHeightAbovePointCloud =
			obj.startPointHeightAbovePointCloud;
		state.ai_road_preview_data.startPointHeightAboveDesignData =
			obj.startPointHeightAboveDesignData;
		state.ai_road_preview_data.endPointHeightAbovePointCloud =
			obj.endPointHeightAbovePointCloud;
		state.ai_road_preview_data.endPointHeightAboveDesignData =
			obj.endPointHeightAboveDesignData;
	},
	set_ai_road_preview_data_property(state, property) {
		state.ai_road_preview_data[property.name] = property.value;
	},
	reset_ai_road_preview_data(state) {
		state.ai_road_preview_data = {
			x1: undefined,
			y1: undefined,
			z1: undefined,
			x2: undefined,
			y2: undefined,
			z2: undefined,
			startPointHeightAbovePointCloud: undefined,
			startPointHeightAboveDesignData: undefined,
			endPointHeightAbovePointCloud: undefined,
			endPointHeightAboveDesignData: undefined,
		};
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	actions: {},
};
